module.exports = __webpack_public_path__ + "img/wine_half_full.0f6f93f0.png";